import React from 'react';
import { i18n } from 'config/locales';
import { Summary, NameSummary } from 'components/Summary';
import Field from 'components/Form/Field';

import { FOREIGN, FOREIGN_ACTIVITIES_ONGOINGSUPPORT } from 'config/formSections/foreign';
import Subsection from 'components/Section/shared/Subsection';
import connectSubsection from 'components/Section/shared/SubsectionConnector';
import Branch from 'components/Form/Branch';
import Show from 'components/Form/Show';
import Accordion from 'components/Form/Accordion';
import ErrorMessage from 'components/ErrorMessage';
import { getDuplicateNamesAndAddresses } from 'helpers/people';
import { foreignSupportAddressNameFields } from 'constants/enums/people';
import OnGoingSupportItem from './OnGoingSupportItem';

const sectionConfig = {
  key: FOREIGN_ACTIVITIES_ONGOINGSUPPORT.key,
  section: FOREIGN.name,
  store: FOREIGN.store,
  subsection: FOREIGN_ACTIVITIES_ONGOINGSUPPORT.name,
  storeKey: FOREIGN_ACTIVITIES_ONGOINGSUPPORT.storeKey,
};
export class OnGoingSupport extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
    this.handleError = this.handleError.bind(this);
  }

  update = (queue) => {
    this.props.onUpdate(this.storeKey, {
      HasOnGoingForeignSupport: this.props.HasOnGoingForeignSupport,
      List: this.props.List,
      ...queue,
    });
  };

  updateHasOnGoingForeignSupport = (values) => {
    this.update({
      HasOnGoingForeignSupport: values,
      List: values.value === 'Yes' ? this.props.List : [],
    });
  };

  updateList = (values) => {
    this.update({
      List: values,
    });
  };

  summary = (item, index) => {
    const o = (item || {}).Item || {};
    const name = NameSummary(o.Name);
    return Summary({
      type: i18n.t('foreign.activities.support.collection.summary.item'),
      index,
      left: name,
      placeholder: i18n.t('foreign.activities.support.collection.summary.unknown'),
    });
  };

  render() {
    const { errors, peopleWhoKnowYou, List } = this.props;
    const accordionErrors = errors && errors.filter((e) => e.indexOf('List.accordion') === 0);

    const duplicatePeopleWhoKnowYou = getDuplicateNamesAndAddresses(List?.items, peopleWhoKnowYou, foreignSupportAddressNameFields);

    const duplicatePeopleWhoKnowYouError = (
      <Field
        className="no-margin-bottom"
        title={i18n.t('relationships.people.error.duplicatePeopleWhoKnowYouError.title')}
        scrollIntoView={this.props.scrollIntoView}
        hideTitle
      >
        <ErrorMessage
          title={i18n.t('relationships.people.error.duplicatePeopleWhoKnowYouError.title')}
          message={[
            i18n.t('relationships.people.error.duplicatePeopleWhoKnowYouError.message'),
            ...duplicatePeopleWhoKnowYou.errors.map((item) => ` - ${item}`)
          ]}
        />
      </Field>
    );

    const duplicatePeopleWhoKnowYouWarning = (
      <ErrorMessage
        isWarning
        title={i18n.t('relationships.people.error.duplicatePeopleWhoKnowYouWarning.title')}
        message={[
          i18n.t('relationships.people.error.duplicatePeopleWhoKnowYouWarning.message'),
          ...duplicatePeopleWhoKnowYou.warnings.map((item) => ` - ${item}`)
        ]}
      />
    );

    return (

      <div
        className="section-content foreign-activities-ongoingsupport"
        data-section={FOREIGN.key}
        data-subsection={FOREIGN_ACTIVITIES_ONGOINGSUPPORT.key}
      >
         <h1 className="section-header">{i18n.t('foreign.pvq.activities.eligible.heading.title')}</h1>

        <Branch
          name="has_foreign_support"
          label={i18n.m('foreign.pvq.activities.ongoingTitle')}
          labelSize="h4"
          {...this.props.HasOnGoingForeignSupport}
          warning
          onUpdate={this.updateHasOnGoingForeignSupport}
          onError={this.handleError}
          required={this.props.required}
          scrollIntoView={this.props.scrollIntoView}
          attribute="HasOnGoingForeignSupport"
        />
        <Show when={this.props.HasOnGoingForeignSupport.value === 'Yes'}>
          <Accordion
            {...this.props.List}
            defaultState={this.props.defaultState}
            onUpdate={this.updateList}
            onError={this.handleError}
            errors={accordionErrors}
            summary={this.summary}
            description={i18n.t('foreign.activities.support.collection.summary.title')}
            appendTitle="Do you have another instance in which you or one of the people listed below is eligible to receive benefits from a foreign country in the future?"
            appendLabel={i18n.t('foreign.activities.support.collection.append')}
            required={this.props.required}
            scrollToBottom={this.props.scrollToBottom}
            scrollIntoView={this.props.scrollIntoView}
            attribute="List"
            additionalErrors={
              (duplicatePeopleWhoKnowYou.errors.length > 0 && duplicatePeopleWhoKnowYouError)
              || (duplicatePeopleWhoKnowYou.warnings.length > 0 && duplicatePeopleWhoKnowYouWarning)
            }
          >
            <OnGoingSupportItem
              name="Item"
              bind
              dispatch={this.props.dispatch}
              addressBooks={this.props.addressBooks}
              required={this.props.required}
              scrollIntoView={this.props.scrollIntoView}
              attribute="List"
              formType={this.props.formType}
            />
          </Accordion>
        </Show>
      </div>

    );
  }
}

OnGoingSupport.defaultProps = {
  name: 'OnGoingSupport',
  HasOnGoingForeignSupport: {},
  List: {},
  onUpdate: () => { },
  onError: (value, arr) => arr,
  section: 'foreign',
  subsection: 'activities/ongoingsupport',
  addressBooks: {},
  dispatch: () => { },
  defaultState: true,
  errors: [],
};

export default connectSubsection(OnGoingSupport, sectionConfig);
